var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 35,
    height: 35,
    fill: "url(#pattern0_32433_32328)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_32433_32328",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_32433_32328",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_32433_32328",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAACDklEQVR4nO3aS04bYRBF4RYDg7MGtggsA2eah2BHwAz2EGeYRIJkelArPbT9q1p1i37cb2y5XEfGFiV3nZmZmZmZmZnZSgEXwA3wBLyxPm/AI3ANnKsiXwIvH73phDz3TRTvZEc+HDvvnT18XNhhV5mh+89kO+whM/TrkSEGr5mh7QSHLuLQRRy6iEMXcegiDl3EoYs49FJCdyuDQ9dw6CIOXcShizh0EYcu4tBFHHqtoYFPwHfgz4h/tH4D34DtieffAJ+Bn+TZA7v+ubM6hEUHAPcJi9+feP4+iMouq0NYZABwBvxLWPhv/1xHZvTvPpW9Qw8Q646IPj7sgz467qKvJ0tWh7ARL2gLfB2+2KJ+AV8aX4ZSWR3C5AOCZIUbe8k7yAcEyQo39pJ3kA8IkhVu7CXvIB8QJCvc2EveQT4gSFa4sZe8g3xAkKxwYy95hwneOqSyOoRN8NYhldUhbIK3DimHHmgzzyT08HjfOopC+9YxhvxPJgix6Fz5YmkDgmSFG3vJO8gHBMkKN/aSd5APCJIVbuwl7yAfECQr3NhL3kE+IEhWuLGXvMOIF+RbR1Fo3zrUoX3rWFboPWv/AU3RrWOHzm1Wh7AJ3jo2Q+z9qn/kuFQ4dA2HLuLQRRy6iEMvPbT959BFHHqGoZW3hbn7kRlaeVuYu9vM0Irbwtw1byNmZmZmZmZmZt1CvQMy/BGYR+BFiwAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebIcon);
export default __webpack_public_path__ + "static/media/web_icon.107e05b987ba66866e766b1d4833abe1.svg";
export { ForwardRef as ReactComponent };